import React__default, { useRef } from 'react';
import { D as DropdownPopper } from './DropdownPopper-TrL9NyIz.js';
import { S as SelectList } from '../SelectList/SelectList-SGDw-BtH.js';
import { u as usePopperSelectListHelper } from './usePopperSelectListHelper-BQY_M0qK.js';
import { g as getPlacement } from './utils-BSiT3_dq.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';

/* eslint-disable @typescript-eslint/no-empty-function */
function getSize(elementRef) {
  let height;
  let width;
  if (elementRef && elementRef.current) {
    const size = elementRef.current.getBoundingClientRect();
    height = size.height;
    width = size.width;
  }
  return {
    height,
    width
  };
}
function DesktopContainer({
  isOpen,
  onClose,
  children,
  shadowRoot,
  trigger,
  preRender,
  postRender,
  selectedValue,
  onChange,
  noWrap,
  focusSelected,
  anchorEl,
  forceOpen,
  popperRef,
  openDirection,
  forceDirection
}) {
  const internalRef = useRef(null);
  const {
    height,
    width
  } = getSize(anchorEl);
  const {
    focusedValue,
    handleKeyDown,
    onPopoverElementDidMount
  } = usePopperSelectListHelper({
    isOpen,
    anchorEl,
    popperRef: popperRef !== null && popperRef !== void 0 ? popperRef : internalRef,
    onClose,
    focusSelected,
    focusAnchorElDisabled: forceOpen
  });
  return /*#__PURE__*/React__default.createElement(DropdownPopper, {
    popperRef: popperRef !== null && popperRef !== void 0 ? popperRef : internalRef,
    isOpen: isOpen,
    onClose: onClose,
    offsetDistance: -Math.abs(height !== null && height !== void 0 ? height : 0),
    $minWidth: width,
    onKeyDown: handleKeyDown,
    popperElementDidMount: onPopoverElementDidMount,
    shadowRoot: shadowRoot,
    trigger: trigger,
    focusFirstElementOnPopoverExited: true,
    placement: getPlacement(openDirection),
    enableFlip: !forceDirection
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    fallbackId: "dropdown-desktop"
  }, preRender === null || preRender === void 0 ? void 0 : preRender(), /*#__PURE__*/React__default.createElement(SelectList, {
    selectedValue: selectedValue,
    onChange: onChange,
    noWrap: noWrap,
    focusedValue: focusedValue,
    afterOnSelect: onClose
  }, children), postRender === null || postRender === void 0 ? void 0 : postRender()));
}
DesktopContainer.defaultProps = {
  selectedValue: undefined,
  preRender: undefined,
  postRender: undefined,
  focusSelected: true,
  anchorEl: undefined,
  forceOpen: false
};

export { DesktopContainer as D };
//# sourceMappingURL=DropdownDesktopContainer-DrAIC1zi.js.map
